<template>
  <div>
    <el-cascader
      ref="cascader"
      v-model="selectAddress"
      style="width: 100%"
      size="small"
      :options="options"
      :props="cascderProps"
      :disabled="disabled"
      v-bind="$attrs"
      :popper-class="popperClass"
      @change="handleChange"
    />
  </div>
</template>

<script>
import { isH5, isMobile } from "@saas/components/src";

import { getJSON } from "@saas/service-api/src/request";
export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    // 值 id: [id, id, id],
    // 值 object: [{id, name}, {id, name}, {id,name}]
    valueType: {
      type: String,
      default: "id",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      options: [],
      selectAddress: [],
      cascderProps: {
        label: "name",
        value: "code",
        children: "children",
      },
      isH5: isH5(),
    };
  },
  watch: {
    value: {
      handler(val) {
        if (val) {
          if (this.valueType === "id") {
            this.selectAddress = val;
          } else {
            this.selectAddress = val.map((item) => {
              return item.id;
            });
          }
        } else {
          this.selectAddress = [];
        }
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    popperClass() {
      return this.isH5 ? "select-address-popper-h5" : "select-address-popper";
    },
  },
  mounted() {
    getJSON(process.env.VUE_APP_CDN_URL + "/cdn/json/district.json").then(
      (res) => {
        this.options = res || [];
      }
    );
  },
  methods: {
    handleChange(value) {
      let data = [];
      const selectNode = this.$refs.cascader.getCheckedNodes();
      if (this.valueType === "id") {
        data = value;
      } else {
        data = selectNode[0].pathNodes.map((item) => {
          return {
            id: item.value,
            name: item.label,
          };
        });
      }
      this.$emit("input", data);
      this.$emit("change", data);
    },
  },
};
</script>

<style lang="scss">
.select-address-popper {
  .el-cascader-node.in-active-path,
  .el-cascader-node.is-selectable.in-checked-path,
  .el-cascader-node.is-active {
    color: #00c89d;
  }
}
.select-address-popper-h5 {
  max-width: 95%;
  .el-cascader-node.in-active-path,
  .el-cascader-node.is-selectable.in-checked-path,
  .el-cascader-node.is-active {
    color: #00c89d;
  }
  .el-cascader-menu {
    min-width: 33%;
    flex: 1;
  }
}
</style>
